module.exports = __webpack_public_path__ + "static/passo-3-c03aa3cdbcf6cd3d1ca449fd3775c558.jpg";